import PhotoSwipe from "photoswipe";
import PhotoSwipeUIDefault from "photoswipe/dist/photoswipe-ui-default";

export default ({
  gallerySelector = ".gallery",
  imgSelector = ".photoswipe--image",
  pswpOptions = {
    bgOpacity: 0.95,
    history: true,
    galleryPIDs: true,
    allowPanToNext: false,

    captionEl: true,
    fullscreenEl: false,
    zoomEl: false,
    shareEl: false,
    counterEl: false,

    showHideOpacity: true,
    getThumbBoundsFn: false,
  },
} = {}) => {
  const pswpEL = document.querySelector(".pswp");
  if (!pswpEL) return;

  let pswp;
  [...document.querySelectorAll(gallerySelector)].forEach((container) => {
    const items = [...container.querySelectorAll(imgSelector)].map(
      (img, index) => {
        img.classList.add("pswp-open");
        img.addEventListener("click", (e) => {
          if (e.which > 1 || e.shiftKey || e.altKey || e.metaKey || e.ctrlKey)
            return;
          e.preventDefault();

          pswp = new PhotoSwipe(
            pswpEL,
            PhotoSwipeUIDefault,
            items,
            Object.assign({ index }, pswpOptions)
          );

          document.body.style.overflow = "hidden";
          pswp.listen("close", () => {
            document.body.style.overflow = "";
          });

          pswp.init();
        });

        const link = img.parentNode;
        const figure = link.parentNode;
        const caption = figure.querySelector("figcaption");

        return {
          title: caption ? caption.innerHTML : img.getAttribute("alt"),
          src: link.getAttribute("href"),
          w: figure.getAttribute("data-width"),
          h: figure.getAttribute("data-height"),
          pid: link.getAttribute("href").split("/").pop(),
        };
      }
    );
  });

  const api = {};
  return api;
};
